import app from '$$app';
import KeyboardNavigation from '../../keyboardNavigation';

export default function (instance) {
  return {
    show(id, column, config, placeholder) {
      const task = instance.getTask(id);
      const position = placeholder.getBoundingClientRectWrapper();

      position.y += 1;

      KeyboardNavigation.toggleState(false);
      app.trigger('showResourcesListForTask', position, task.id, task.gantt_id, 'gridView', () => {
        instance.ext.inlineEditors.hide();
      });
    },

    hide() {
      KeyboardNavigation.toggleState(true);
      app.trigger('hideResourcesListForTask');
    },

    set_value(value, id, column, node) {
    },

    get_value(id, column, node) {
    },

    is_changed(value, id, column, node) {
      return true;
    },

    is_valid(value, id, column, node) {
      return true;
    },

    save(id, column, node) {
    },

    focus(node) {
    },
  };
}
